import { CircularProgress } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import usePrimaryColor from "@root/hooks/usePrimaryColor";

export const PrimaryDarkButton = ({
    loading,
    title,
    onClick,
    type,
    additionalAttribute,
    disabled,
    loadingText,
    padding,
    bgColor,
    imgSrc,
    imgRight = true
}: IButton) => {


    const { defPrimaryColor } = usePrimaryColor();
    const colorChange = bgColor || defPrimaryColor

    const useStyles = makeStyles(() =>
        createStyles({
            button: (props: { padding?: string; defPrimaryColor?: string; bgColor?: string; imgSrc?: string; imgRight?: boolean }) => ({
                fontFamily: "Wix Madefor Text",
                fontSize: "16px",
                fontWeight: 500,
                lineHeight: "100%",
                color: "#ffffff",
                maxHeight: "48px",
                backgroundColor: colorChange,
                borderRadius: "40px",
                padding: props.padding ?? "14px 0px",
                position: "relative",
                wordWrap: "break-word",
                display: "flex !important",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
                border: `1px solid ${colorChange}`,
                boxShadow: "none",

                "&:disabled": {
                    backgroundColor: colorChange,
                    border: `1px solid ${colorChange}`,
                    opacity: 0.4,
                    cursor: "not-allowed !important",
                },

                "&:hover": {
                    backgroundColor: colorChange,
                    border: `1px solid ${colorChange}`,
                    opacity: 0.4,
                },

                "&:active": {
                    backgroundColor: ` ${colorChange} !important`,
                    border: `1px solid ${colorChange} !important`,
                    opacity: "0.4 !important",
                },

                "&:focus-visible": {
                    backgroundColor: ` ${colorChange} !important`,
                    border: `1px solid ${colorChange} !important`,
                    opacity: "0.4 !important",
                    boxShadow: "none",
                }
            }),

        })
    );

    const classes = useStyles({ padding, defPrimaryColor });

    return (
        <>
            <button
                type={type}
                disabled={loading || disabled}
                className={`${classes.button} btn btn-primary block w-100`}
                {...additionalAttribute}
                onClick={onClick}
            >
                {loading ? (
                    <div className="flex items-center gap-[8px]">
                        <CircularProgress sx={{ scale: "0.6", color: "white" }} />
                        {loadingText && <span>{loadingText}</span>}
                    </div>
                ) : (
                    <>
                        {!imgRight && imgSrc && (
                            <img className="absolute left-6 rotate-180" src={imgSrc} alt="icon" />
                        )}
                        {title}
                        {imgRight && imgSrc && (
                            <img className="absolute right-6" src={imgSrc} alt="icon" />
                        )}
                    </>
                )}
            </button>
        </>
    );
};

interface IButton {
    loading?: boolean;
    title: string;
    onClick?: () => void;
    type?: string;
    additionalAttribute?: any;
    disabled?: boolean;
    loadingText?: string;
    padding?: string;
    bgColor?: string;
    imgSrc?: any;
    imgRight?: boolean;
}
